/**
 * PASO 3 DEL QUINCENAL · TU FEEDBACK Y TUS AJUSTES
 *
 * «Todo lo validado antes del 1 de septiembre», «Las tres pantallas»:
 *
 *     3  TU FEEDBACK Y TUS AJUSTES
 *     Este tercer paso es cosa nuestra.
 *     Te avisamos por aquí cuando tengas nuestra respuesta.
 *
 * ES UN PASO Y NO UN «GRACIAS». Sale en la lista de arriba desde la primera pantalla, así
 * que el cliente sabe desde el principio que después de mandar el reporte pasa algo.
 *
 * SIN DÍA NI HORA (Francisco, 18-10: «no hagas promesas»). Decía «Recibirás respuesta antes
 * del viernes a las 3, hora de España».
 *
 * SALVO EL QUINCENAL DEL 24-10: su documento la pide y vuelve AQUÍ y solo aquí, «Te daremos
 * respuesta el viernes antes de las 15:00». La frase la manda el servidor
 * (`ficha.frase_al_enviar`, `core/promesa_del_reporte.frase_al_enviarlo`) y sustituye a la
 * segunda línea; sin plan personalizado no llega y no se promete nada (21-10).
 */
import React from 'react';
import { CabeceraDePasos, RotuloDelPaso, PASOS_DEL_QUINCENAL, ROTULOS_DEL_QUINCENAL } from './PasosDelMensual';

const ORANGE = '#FF671F';

/** Los pasos que se le anuncian: SIN PLAN PERSONALIZADO (Francisco, 21-10) no hay tercero,
 *  porque nadie le va a contestar y no se le promete. `conRespuesta` es `con_respuesta` de
 *  la ficha del reporte (lo decide el servidor, `tiene_entrenador_detras`). */
export const pasosDelRapido = (conRespuesta = true) =>
    (conRespuesta ? PASOS_DEL_QUINCENAL : PASOS_DEL_QUINCENAL.slice(0, 2));

const QuincenalPaso3 = ({ titulo = 'Reporte quincenal', conRespuesta = true, fraseAlEnviar = null }) => (!conRespuesta ? (
    // Sin promesa de respuesta ni «te contestaremos»: que lo ha enviado, y nada más.
    <div className="space-y-4" data-testid="quincenal-enviado-sin-respuesta">
        <CabeceraDePasos paso={3} pasos={pasosDelRapido(false)} titulo={titulo} />
        <div className="rounded-2xl border border-border bg-card p-4">
            <p className="text-base font-bold text-foreground">Reporte enviado.</p>
        </div>
    </div>
) : (
    <div className="space-y-4" data-testid="quincenal-paso3">
        <CabeceraDePasos paso={3} pasos={PASOS_DEL_QUINCENAL} titulo={titulo} />
        <RotuloDelPaso paso={3} rotulos={ROTULOS_DEL_QUINCENAL} />

        <div className="rounded-2xl border p-4 space-y-2"
            style={{ borderColor: `${ORANGE}55`, backgroundColor: `${ORANGE}0D` }}
            data-testid="quincenal-promesa">
            <p className="text-base font-bold text-foreground">
                Este tercer paso es cosa nuestra.
            </p>
            <p className="text-sm text-foreground/80" data-testid="quincenal-frase-al-enviar">
                {fraseAlEnviar || 'Te avisamos por aquí cuando tengas nuestra respuesta.'}
            </p>
        </div>
    </div>
));

export default QuincenalPaso3;
